import { createAction } from '@reduxjs/toolkit';
import { RequestError, HelpInfosFilter } from 'types';
import { State } from './types';
import { createActionWithCallback } from '../utils';

export const fetchHelpInfos = createAction('help-infos/fetch', (payload?: HelpInfosFilter) => ({
  payload,
  meta: { isMessageAssistant: false },
}));

export const fetchedHelpInfos = createAction('help-infos/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const fetchHelpInfosMessageAssisant = createActionWithCallback<State['data'], Error>()(
  'help-infos-message-assistant/fetch',
  (payload?: HelpInfosFilter) => {
    return {
      payload,
      meta: { isMessageAssistant: true },
    };
  }
);

export const fetchedHelpInfosMessageAssisant = createAction(
  'help-infos-message-assistant/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchHelpInfos,
  fetchedHelpInfos,
  fetchHelpInfosMessageAssisant,
  fetchedHelpInfosMessageAssisant,
};
